define("settings/components/cluster/new-team-member", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div>
    <div class="u--col__9 dd-privacy-mask-user-input">
      <p class="u--text--md u--m__b__0">{{@member.name}}</p>
      <p class="u--text--sm u--text--light">{{@member.email}}</p>
    </div>
  
    <div class="u--col__3 u--text--right">
      <Shared::Ui::Button @onClick={{@createMember}} @variant="default">
        {{svg-jar "add" class="o--icon u--m__r"}}{{t "account.groups.group.users.add"}}
      </Shared::Ui::Button>
    </div>
    <div class="u--col__12">
      <hr class="u--m__t__0 u--m__b" />
    </div>
  </div>
  */
  {
    "id": "CZH34jLu",
    "block": "[[[10,0],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--col__9 dd-privacy-mask-user-input\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--text--md u--m__b__0\"],[12],[1,[30,1,[\"name\"]]],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--text--sm u--text--light\"],[12],[1,[30,1,[\"email\"]]],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"u--col__3 u--text--right\"],[12],[1,\"\\n    \"],[8,[39,0],null,[[\"@onClick\",\"@variant\"],[[30,2],\"default\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,1],[\"add\"],[[\"class\"],[\"o--icon u--m__r\"]]]],[1,[28,[35,2],[\"account.groups.group.users.add\"],null]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--col__12\"],[12],[1,\"\\n    \"],[10,\"hr\"],[14,0,\"u--m__t__0 u--m__b\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@member\",\"@createMember\"],false,[\"shared/ui/button\",\"svg-jar\",\"t\"]]",
    "moduleName": "settings/components/cluster/new-team-member.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});